import { getI18nCookieData } from '../modules/i18n';
import { addToTrackingData } from '../modules/tracking';

const i18nData = getI18nCookieData();

let internalUser = {};
const cachedStatus = localStorage.getItem('isInternalUser');

if (cachedStatus && cachedStatus === 'true') {
  internalUser = { is_internal_user: true };
} else if (cachedStatus && cachedStatus === 'false') {
  internalUser = { is_internal_user: false };
}
const locationData = {
  event: 'page_data_ready',
  location_country: i18nData.country.toLocaleLowerCase(),
  location_language: i18nData.language,
  location_region: i18nData.region,
  ...internalUser
};

addToTrackingData(locationData);
